"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "BasesController", {
    enumerable: true,
    get: function() {
        return BasesController;
    }
});
const _common = require("@nestjs/common");
const _isdocker = /*#__PURE__*/ _interop_require_default(require("is-docker"));
const _nocodbsdk = require("nocodb-sdk");
const _globalguard = require("~/guards/global/global.guard");
const _PagedResponse = require("~/helpers/PagedResponse");
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _packageVersion = require("~/utils/packageVersion");
const _basesservice = require("~/services/bases.service");
const _extractidsmiddleware = require("~/middlewares/extract-ids/extract-ids.middleware");
const _models = require("~/models");
const _metaapilimiterguard = require("~/guards/meta-api-limiter.guard");
const _tenantcontextdecorator = require("~/decorators/tenant-context.decorator");
const _config = require("~/interface/config");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
let BasesController = class BasesController {
    async list(context, queryParams, req) {
        const bases = await this.projectsService.baseList(context, {
            user: req.user,
            query: queryParams
        });
        return new _PagedResponse.PagedResponseImpl(bases, {
            count: bases.length,
            limit: bases.length
        });
    }
    async baseInfoGet() {
        var _Noco_getConfig_meta_db, _Noco_getConfig_meta, _Noco_getConfig;
        return {
            Node: process.version,
            Arch: process.arch,
            Platform: process.platform,
            Docker: (0, _isdocker.default)(),
            RootDB: (_Noco_getConfig = _Noco.default.getConfig()) == null ? void 0 : (_Noco_getConfig_meta = _Noco_getConfig.meta) == null ? void 0 : (_Noco_getConfig_meta_db = _Noco_getConfig_meta.db) == null ? void 0 : _Noco_getConfig_meta_db.client,
            PackageVersion: _packageVersion.packageVersion
        };
    }
    async baseGet(context, baseId) {
        const base = await this.projectsService.getProjectWithInfo(context, {
            baseId: baseId,
            includeConfig: false
        });
        this.projectsService.sanitizeProject(base);
        return base;
    }
    async baseUpdate(context, baseId, body, req) {
        const base = await this.projectsService.baseUpdate(context, {
            baseId,
            base: body,
            user: req.user,
            req
        });
        return base;
    }
    async baseDelete(context, baseId, req) {
        const deleted = await this.projectsService.baseSoftDelete(context, {
            baseId,
            user: req.user,
            req
        });
        return deleted;
    }
    async baseCreate(context, baseBody, req) {
        const base = await this.projectsService.baseCreate({
            base: baseBody,
            req,
            user: req['user']
        });
        return base;
    }
    async hasEmptyOrNullFilters(context, baseId) {
        return await _models.Filter.hasEmptyOrNullFilters(context, baseId);
    }
    constructor(projectsService){
        this.projectsService = projectsService;
    }
};
_ts_decorate([
    (0, _extractidsmiddleware.Acl)('baseList', {
        scope: 'org'
    }),
    (0, _common.Get)([
        '/api/v1/db/meta/projects/',
        '/api/v2/meta/bases/'
    ]),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Query)()),
    _ts_param(2, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof Record === "undefined" ? Object : Record,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], BasesController.prototype, "list", null);
_ts_decorate([
    (0, _extractidsmiddleware.Acl)('baseInfoGet'),
    (0, _common.Get)([
        '/api/v1/db/meta/projects/:baseId/info',
        '/api/v2/meta/bases/:baseId/info'
    ]),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", []),
    _ts_metadata("design:returntype", Promise)
], BasesController.prototype, "baseInfoGet", null);
_ts_decorate([
    (0, _extractidsmiddleware.Acl)('baseGet'),
    (0, _common.Get)([
        '/api/v1/db/meta/projects/:baseId',
        '/api/v2/meta/bases/:baseId'
    ]),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('baseId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], BasesController.prototype, "baseGet", null);
_ts_decorate([
    (0, _extractidsmiddleware.Acl)('baseUpdate'),
    (0, _common.Patch)([
        '/api/v1/db/meta/projects/:baseId',
        '/api/v2/meta/bases/:baseId'
    ]),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('baseId')),
    _ts_param(2, (0, _common.Body)()),
    _ts_param(3, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        typeof Record === "undefined" ? Object : Record,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], BasesController.prototype, "baseUpdate", null);
_ts_decorate([
    (0, _extractidsmiddleware.Acl)('baseDelete'),
    (0, _common.Delete)([
        '/api/v1/db/meta/projects/:baseId',
        '/api/v2/meta/bases/:baseId'
    ]),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('baseId')),
    _ts_param(2, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], BasesController.prototype, "baseDelete", null);
_ts_decorate([
    (0, _extractidsmiddleware.Acl)('baseCreate', {
        scope: 'org'
    }),
    (0, _common.Post)([
        '/api/v1/db/meta/projects',
        '/api/v2/meta/bases'
    ]),
    (0, _common.HttpCode)(200),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Body)()),
    _ts_param(2, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _nocodbsdk.ProjectReqType === "undefined" ? Object : _nocodbsdk.ProjectReqType,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], BasesController.prototype, "baseCreate", null);
_ts_decorate([
    (0, _extractidsmiddleware.Acl)('hasEmptyOrNullFilters'),
    (0, _common.Get)([
        '/api/v1/db/meta/projects/:baseId/has-empty-or-null-filters',
        '/api/v2/meta/bases/:baseId/has-empty-or-null-filters'
    ]),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('baseId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], BasesController.prototype, "hasEmptyOrNullFilters", null);
BasesController = _ts_decorate([
    (0, _common.UseGuards)(_metaapilimiterguard.MetaApiLimiterGuard, _globalguard.GlobalGuard),
    (0, _common.Controller)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _basesservice.BasesService === "undefined" ? Object : _basesservice.BasesService
    ])
], BasesController);
